import { useEffect, useState } from 'react';
import { GetServerSideProps } from 'next';

import checkAuth from 'global/api/auth';
import { IGoodCompare } from 'entities/products/model/IGood';
import { IAttributeCompare } from 'src/models/IAttributes';

import type { IError } from 'src/models/IError';
import type { IProfile } from 'app/profile/Data';
import { Breadcrumbs, BreadcrumbType } from 'app/shared';
import { useDispatch } from 'shared/lib/hooks/useDispatch';
import CompareList from '../components/Compare/List';
import { OneClickModal } from 'widgets/products';
import { CartModal } from 'widgets/products';

import { closeOneClickModal } from 'src/store/goods';

import type { IProductError } from 'entities/products/lib/checkProductToBuy';

import styles from 'global/styles/Home.module.scss';
import { api } from 'global/api';
import CartItemChangeModal from 'components/Cart/Modal/CartItemChangeModal';

const breadcrumbs: BreadcrumbType[] = [
  {
    title: 'Сравнение характеристик',
    href: '/compare',
  },
];

type Props = {
  goods: IGoodCompare[];
  attributes: IAttributeCompare[];
  user: IProfile | null;
};

export default function Compare({ goods, attributes, user }) {
  const [products, setProducts] = useState<IGoodCompare[]>([]);
  const [attributesList, setAttributesList] = useState<IAttributeCompare[]>([]);
  const [errorToBuy, setErrorToBuy] = useState<IProductError | null>(null);
  const dispatch = useDispatch();

  const onOneClickOrderError = (productId: number | string, errors: IError[], goodError?: IProductError | null) => {
    if (goodError) {
      setErrorToBuy(goodError);
      dispatch(closeOneClickModal());
      const newProducts = products.map((product) => {
        if (product.id == productId) {
          return { ...product, is_available: false };
        }
        return product;
      });

      setProducts(newProducts);
    }
    // if (!errors.some((err) => err.source === 'quantity')) return;

    // const newProducts = products.map((product) => {
    //   if (product.id == productId) {
    //     return { ...product, is_available: false };
    //   }
    //   return product;
    // });

    // dispatch(closeOneClickModal());
    // dispatch(setCartError(true));
    // setProducts(newProducts);
  };

  /**Если в одном из товаров указан вес, то добавляем в характеристики вес */
  useEffect(() => {
    const hasProductWeight = goods.some((good) => good?.product_weight);
    if (hasProductWeight) {
      const newProducts = goods.map((good) =>
        !Array.isArray(good.attributes_value)
          ? {
              ...good,
              attributes_value: {
                ...good.attributes_value,
                weight: good?.product_weight / 1000 || '',
              },
            }
          : {
              ...good,
              attributes_value: { weight: good?.product_weight / 1000 || '' },
            }
      );

      const newAttributes = attributes.concat({
        id: 'weight',
        name: 'Вес товара (кг)',
        data_type: 'INTEGER',
      });
      setProducts(newProducts);
      setAttributesList(newAttributes);
    } else {
      setProducts(goods);
      setAttributesList(attributes);
    }
  }, [goods, attributes]);

  const handleCloseError = () => {
    setErrorToBuy(null);
  };

  return (
    <div>
      <CartModal />
      <OneClickModal onError={onOneClickOrderError} user={user} />

      {errorToBuy && (
        <CartItemChangeModal
          title={errorToBuy.title || ''}
          description={errorToBuy.description || ''}
          onClose={handleCloseError}
        />
      )}

      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className="container">
        <h1 className={styles.sectionTitle}>Сравнить</h1>
        <CompareList initialGoods={products} initialAttributes={attributesList} />
      </div>
    </div>
  );
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ req }) => {
  let goods = [];
  let attributes = [];
  let user = null;

  try {
    const isLoggedIn = await checkAuth(req, false, true);
    let compareRes = null;

    if (isLoggedIn) {
      compareRes = await api.getAuthCompareList();

      const propfileRes = await api.getProfile();
      user = propfileRes.data.data;
    } else {
      const compareIds = req.cookies['compareIds'];
      if (compareIds) {
        compareRes = await api.getCompareList(compareIds.split(','));
      }
    }
    if (compareRes) {
      goods = compareRes.data.data.products.map((product: IGoodCompare) => {
        return {
          ...product,
          price: product.price / 100,
          list_price: product.list_price ? product.list_price / 100 : null,
        };
      });
      attributes = compareRes.data.data.attributes;
    }
  } catch (error) {
    console.error(error);
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    };
  }

  return {
    props: {
      goods,
      attributes,
      user,
    },
  };
};
